import { TriangleAlert } from 'lucide-react'
import type { ReactNode } from 'react'
import { Button } from './Button'
import { cn } from '@/lib/cn'

export function ErrorNotice({ title, children, onRetry, onDismiss, busy, className }: { title?: string; children: ReactNode; onRetry?: () => void; onDismiss?: () => void; busy?: boolean; className?: string }) {
  return <div role="alert" className={cn('my-3 flex flex-wrap items-center gap-3 rounded-lg border border-border bg-surface-raised p-4', className)}>
    <TriangleAlert className="h-4 w-4 shrink-0 text-danger" aria-hidden="true" />
    <div className="min-w-0 flex-1 text-sm text-text-muted">{title ? <p className="mb-1 font-medium text-text">{title}</p> : null}{children}</div>
    {onRetry ? <Button variant="secondary" size="sm" loading={busy} onClick={onRetry}>Try again</Button> : null}
    {onDismiss ? <Button variant="ghost" size="sm" onClick={onDismiss}>Dismiss</Button> : null}
  </div>
}
